const UNKNOWN = 'Unknown';

const normalizeString = (value) => {
  if (typeof value !== 'string') return '';
  return value.trim();
};

const prettyValue = (value) => {
  const normalized = normalizeString(value);
  if (!normalized) return UNKNOWN;
  return normalized
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const pickPromptText = (scan) => (
  scan?.hairstyle_suggestions?.promptUsed ||
  scan?.generated_hairstyle_prompt ||
  scan?.custom_prompt ||
  scan?.prompt ||
  scan?.lookPrompt ||
  ''
);

const extractHairstyleFromPrompt = (promptText) => {
  const prompt = normalizeString(promptText);
  if (!prompt) return '';

  const lines = prompt
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);

  for (const line of lines) {
    if (line.startsWith('•')) continue;
    if (/^resolved style:/i.test(line)) {
      return normalizeString(line.replace(/^resolved style:\s*/i, ''));
    }
    return line;
  }

  return '';
};

const extractHairProfileFromPrompt = (promptText) => {
  const prompt = normalizeString(promptText);
  if (!prompt) return {};

  const verboseMatch = prompt.match(
    /visible hair profile:\s*([^,.\n]+)\s+texture,\s*([^,.\n]+)\s+density,\s*([^,.\n]+)\s+strand thickness,\s*([^,.\n]+)\s+current length/i
  );
  if (verboseMatch) {
    return {
      curlType: verboseMatch[1],
      density: verboseMatch[2],
      strandThickness: verboseMatch[3],
      currentLength: verboseMatch[4],
    };
  }

  const adaptedMatch = prompt.match(/adapted to your hair type\s*\(([^,)]+),\s*([^)]+)\)/i);
  if (adaptedMatch) {
    return {
      curlType: adaptedMatch[1],
      density: adaptedMatch[2],
    };
  }

  return {};
};

const extractStructuredHairProfile = (scan) => (
  scan?.hairProfile ||
  scan?.hair_profile ||
  scan?.gemini_analysis?.hair_profile ||
  scan?.gemini_analysis?.hairProfile ||
  scan?.hairstyle_suggestions?.hairProfile ||
  scan?.hairstyle_suggestions?.hair_profile ||
  scan?.analysis_metadata?.hair_profile ||
  scan?.analysis_metadata?.hairProfile ||
  {}
);

export const buildAiPromptSummary = (scan) => {
  const promptText = pickPromptText(scan);
  const structuredHairProfile = extractStructuredHairProfile(scan);
  const promptHairProfile = extractHairProfileFromPrompt(promptText);
  const hairProfile = {
    curlType: structuredHairProfile?.curlType || structuredHairProfile?.curl_type || promptHairProfile.curlType || '',
    density: structuredHairProfile?.density || promptHairProfile.density || '',
    strandThickness: structuredHairProfile?.strandThickness || structuredHairProfile?.strand_thickness || promptHairProfile.strandThickness || '',
    currentLength: structuredHairProfile?.currentLength || structuredHairProfile?.current_length || promptHairProfile.currentLength || '',
  };

  return {
    hairstyle: prettyValue(
      scan?.haircut ||
      scan?.resolvedStyleName ||
      scan?.resolved_style_name ||
      scan?.hairstyle_suggestions?.hairstyle ||
      scan?.hairstyle_suggestions?.resolvedStyleName ||
      scan?.hairstyle_suggestions?.selectedSuggestionName ||
      extractHairstyleFromPrompt(promptText)
    ),
    faceShape: prettyValue(
      scan?.hairstyle_suggestions?.faceShape ||
      scan?.faceShape ||
      scan?.face_shape
    ),
    hairProfile: {
      curlType: prettyValue(hairProfile.curlType),
      density: prettyValue(hairProfile.density),
      thickness: prettyValue(hairProfile.strandThickness),
      length: prettyValue(hairProfile.currentLength),
    },
  };
};
